import { Text } from "../Text/Text";
import React from "react";
import * as styles from "./card.module.scss";
import Tool from "../../../static/images/tools.svg";
import Sport from "../../../static/images/sport2.svg";
import Cup from "../../../static/images/cup.svg";
import Network from "../../../static/images/networking.svg";

interface Props {
  className?: string;
}

const content = [
  {
    picto: Tool,
    text: "12 practical workshops with 7 leading experts in implant dentistry",
  },
  {
    picto: Sport,
    text: "Various activities to enjoy and relax",
  },
  {
    picto: Cup,
    text: "A golf competition to try to win an EAO trophy",
  },
  {
    picto: Network,
    text: "Exclusive networking with 120 international participants",
  },
];

export const Card: React.FC<Props> = ({ className }) => {
  return (
    <div className={`${className} ${styles.wrapper}`}>
      {content.map((card: any, index: number) => {
        return (
          <div key={`card-${index}`} className={styles.card}>
            <img src={card.picto} alt={"picto"} className={styles.image} />
            <Text text={card.text} className={styles.text} />
          </div>
        );
      })}
    </div>
  );
};
